export default "__VITE_ASSET__fAUOZ5CZ__"